import {
  Box,
  Heading,
  Link as ChakraLink,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { PREVIEW_PRIMARY_RGB } from "../../helpers/theme";
import GoogleIcon from "../primary/Icon";
import { ServiceSummary } from "./ServiceSummaries";

export const ServiceItem = (props: ServiceSummary) => {
  const { title, summary, icon, slug } = props;

  return (
    <ChakraLink
      as={RouterLink}
      to={`/learning/${slug}`}
      _hover={{ textDecoration: "none" }}
    >
      <Box
        as="article"
        borderRadius="2xl"
        h="full"
        transition="box-shadow 0.2s ease, transform 0.2s ease"
        _hover={{
          boxShadow: `0 12px 40px rgba(${PREVIEW_PRIMARY_RGB}, 0.14)`,
          transform: "translateY(-2px)",
        }}
      >
        <VStack
          align="stretch"
          spacing={4}
          p={6}
          h="full"
          bg="cle.white"
          borderRadius="2xl"
          borderWidth="1px"
          borderColor={`rgba(${PREVIEW_PRIMARY_RGB}, 0.14)`}
          boxShadow="0 4px 24px rgba(0, 0, 0, 0.04)"
        >
          <Box
            w={14}
            h={14}
            borderRadius="xl"
            bg="cle.iconWell"
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="preview.primary"
          >
            {icon}
          </Box>
          <Box display="flex" flexDirection="column" flex="1" minH={0}>
            <Heading as="h3" fontSize="xl" color="preview.neutral" mb={4}>
              {title}
            </Heading>
            <Box color="cle.muted" display="flex" flexDirection="column" flex="1">
              <Text fontSize="sm" lineHeight={1.7}>
                {summary}
              </Text>
              <Box color="preview.primary" mt="auto" pt={4}>
                <GoogleIcon name="trending_flat" fontSize={24} />
              </Box>
            </Box>
          </Box>
        </VStack>
      </Box>
    </ChakraLink>
  );
};
